import SDKConfiguraitonModel from "../Configurator/Models/SDKConfiguraitonModel";
import { OddClientConfig } from "../Configurator/Types/ConfiguratorTypes";
import MatchOddsFilters from "../Namespaces/Odds/Models/Filters/MatchOddsFilters";
import MatchOddsRemapper from "../Namespaces/Odds/Models/Remappers/MatchOddsRemapper";

export default class Sportal365Https {
  protected readonly footballBaseUrl: string =
    "https://football.api.sportal365.com/";
  private retryRequest: boolean = false;
  private readonly oddClient: OddClientConfig = null;
  private readonly remapper: MatchOddsRemapper = null;

  constructor(config: SDKConfiguraitonModel) {
    this.oddClient = config.oddClient;
    this.remapper = new MatchOddsRemapper();
  }

  public getMatchOdds = async (
    matchIds: string[],
    filters: MatchOddsFilters
  ) => {
    const url = `v2/matches/livescore?odd_client=${
      this.oddClient.name
    }&match_ids=${matchIds.join(",")}${filters.constructFiltersUrl()}`;
    const warnMessage = `Error while fetching match odds for matchIds: ${matchIds.join(
      ","
    )}`;

    const data = await this.fetchWithAuth(url, warnMessage);
    const overGoals =
      filters.marketTypes && filters.marketTypes.length > 0
        ? filters.marketTypes.filter((m) => m.includes("OVER"))
        : [];

    return this.remapper.fromResponse(data, overGoals);
  };

  private getAuthHeaders = () => {
    const basicAuth =
      typeof window !== "undefined"
        ? window.btoa(
            `${this.oddClient.credentials.username}:${this.oddClient.credentials.password}`
          )
        : Buffer.from(
            `${this.oddClient.credentials.username}:${this.oddClient.credentials.password}`
          ).toString("base64");

    return {
      "Content-Type": "application/json",
      Authorization: `Basic ${basicAuth}`,
    };
  };

  private fetchWithAuth = async (url: string, warnMessage: string) => {
    const response = await fetch(this.footballBaseUrl + url, {
      headers: this.getAuthHeaders(),
    });
    const data = await response.json();

    if (!response.ok) {
      if (
        (response.status === 401 || response.status === 403) &&
        !this.retryRequest
      ) {
        this.retryRequest = true;
        await this.fetchWithAuth(url, warnMessage);
      }

      this.retryRequest = false;
      console.warn(warnMessage, data);
      throw data;
    }

    this.retryRequest = false;

    return data;
  };
}
